import { useState } from 'react'

function useDeleteJob() {
    const [jobDeleting, setJobDeleting] = useState();

    const deleteJob = async (jobId) => {
        const confirm = window.confirm("Are you sure to delete?");
        if (!confirm) return;
        setJobDeleting(true);
        try {
            const res = await fetch(`/sis/jobs/${jobId}`, { method: 'delete' });
            setJobDeleting(false);
            if (res.ok) return true;
        } catch (error) {
            setJobDeleting(false);
        }
    }

    return { deleteJob, jobDeleting };
}

export default useDeleteJob
